import React from 'react';
import clsx from 'clsx';
import { firstErrorMessage } from '@/utils/errors';
import Filter from '@/components/Filter';
import { pagingAttributes } from '@/hooks/paging';
import { REQUEST_REVIEW_SUGGESTIONS, REQUEST_SUGGESTIONS } from '../constants';
import RequestsFilterToggles from '../components/RequestsFilterToggles';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestsFilters = ({
  category,
  className,
  fluid,
  hideFlags,
}) => {
  const {
    approvedFlag,
    deniedFlag,
    errorFlag,
    filterTerm,
    pendingFlag,
    readErrors,
    review,
  } = Selectors.useRequestsFilters({ category });
  const fetchData = Events.useFetchRequests(category);
  const updateFilterTerm = Events.useUpdateRequestsFilter(category);
  const updateFlags = Events.useUpdateRequestsFlags(category);

  const label = hideFlags ? undefined : (
    <RequestsFilterToggles
      approvedFlag={approvedFlag}
      deniedFlag={deniedFlag}
      errorFlag={errorFlag}
      pendingFlag={pendingFlag}
      showErrors={!review}
      updateFlags={updateFlags}
    />
  );

  return (
    <Filter
      fluid={fluid}
      className={clsx('aridhia-requests-filter', className)}
      filterTerm={filterTerm}
      updateFilter={updateFilterTerm}
      error={firstErrorMessage(readErrors)}
      onFilter={() => fetchData(pagingAttributes())}
      label={label}
      suggestions={review ? REQUEST_REVIEW_SUGGESTIONS : REQUEST_SUGGESTIONS}
    />
  );
};

export default RequestsFilters;
